export default function NoContents({ textData }) {
	return (
		<div className='no-contents'>
			<h1>{textData.myPage['No Contents']}</h1>
			<h3>{textData.myPage['No Contents Detail']}</h3>
		</div>
	);
}
